var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('spinner',{staticStyle:{"position":"absolute","margin":"100px 45%"},attrs:{"size":"huge"}})}
var staticRenderFns = []

export { render, staticRenderFns }